function get_workflow_name(binding = {}) {
  return binding.workflow_name || binding.name || 'Untitled workflow';
}

function get_workflow_status(binding = {}) {
  if (binding.workflow_status || binding.status) {
    return String(binding.workflow_status || binding.status).toUpperCase();
  }

  return binding.is_active === false ? 'INACTIVE' : 'ACTIVE';
}

function get_stage_summary(binding = {}) {
  return binding.stage_summary
    || binding.description
    || 'Workflow stages configured in workflow setup';
}

function map_binding(binding = {}) {
  const workflow_name = get_workflow_name(binding);

  return {
    workflow_name,
    status: get_workflow_status(binding),
    stage_summary: get_stage_summary(binding),
    raw: binding,
    id: binding.id || binding.workflow || workflow_name,
  };
}

export default {
  name: 'WorkflowBinding',
  emits: ['bind-workflow', 'remove-workflow', 'update:selected-workflow-id'],
  props: {
    entityTypeName: {
      type: String,
      default: 'Entity',
    },
    systemName: {
      type: String,
      default: 'ent_supplier_v2',
    },
    formBindingsCount: {
      type: Number,
      default: 0,
    },
    workflowBindings: {
      type: Array,
      default: () => [],
    },
    availableWorkflows: {
      type: Array,
      default: () => [],
    },
    selectedWorkflowId: {
      type: [String, Number],
      default: '',
    },
    creatingWorkflowBinding: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    has_workflow() {
      return this.workflowBindings.length > 0;
    },
    workflow_count() {
      return this.workflowBindings.length;
    },
    current_bindings() {
      return this.workflowBindings.map(map_binding);
    },
  },
};
